import { lazy } from 'react';
// project import
import Loadable from 'components/Loadable';

// ==============================|| ROUTES ITEMS - CROWDSOURCE ||============================== //

// render - threat monitor
const ThreatMonitorPage = Loadable(
    lazy(() => import('pages/nostradamus/crowdsource/ThreatMonitorPage')),
);

const crowdsource = {
    path: '/threat-monitor',
    element: <ThreatMonitorPage />,
};

export default crowdsource;
